const projectUsersReducer = (data = 'unset', action) => {
    switch(action.type){
        case 'SET_USERS':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default projectUsersReducer;